var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { __decorate, __metadata } from "tslib";
import rotService from "@/core/services/rotService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { QuestaoActions } from "@/store/enums/rotEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let QuestaoModule = class QuestaoModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = QuestaoActions.DOWNLOAD_PLANILHA]() {
        return new Promise((resolve, reject) => {
            rotService.getFile("Questao/DownloadPlanilhaModelo")
                .then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Planilha_Modelo_Questao.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                resolve(response);
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors);
                }
                else {
                    reject("Erro ao baixar a planilha.");
                }
            });
        });
    }
    [_b = QuestaoActions.UPLOAD_PLANILHA](file) {
        const formData = new FormData();
        formData.append('file', file); // Adiciona o arquivo ao FormData
        return new Promise((resolve, reject) => {
            rotService.postFile("Questao/ImportarPlanilha", formData)
                .then(({ data }) => {
                resolve(data); // Sucesso
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors); // Rejeita com o erro
                }
                else {
                    reject("Erro ao enviar a planilha.");
                }
            });
        });
    }
    [_c = QuestaoActions.POST_QUESTAO](data) {
        return new Promise(resolve => {
            rotService.post("Questao/PostBack", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = QuestaoActions.PUT_QUESTAO](data) {
        return new Promise(resolve => {
            rotService.put("Questao/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = QuestaoActions.DELETE_QUESTAO](data) {
        return new Promise(resolve => {
            rotService.delete("Questao/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = QuestaoActions.DELETE_RANGE_QUESTAO](data) {
        return new Promise(resolve => {
            rotService.delete("Questao/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = QuestaoActions.FILTER_QUESTAO](data) {
        return new Promise(resolve => {
            rotService.post("Questao/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = QuestaoActions.GET_QUESTAO]() {
        return new Promise(resolve => {
            rotService.get("Questao/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = QuestaoActions.GETWITHDISABLED_QUESTAO]() {
        return new Promise(resolve => {
            rotService.get("Questao/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = QuestaoActions.GET_BY_ID_QUESTAO](data) {
        return new Promise(resolve => {
            rotService.get("Questao/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], QuestaoModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [File]),
    __metadata("design:returntype", void 0)
], QuestaoModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], QuestaoModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], QuestaoModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], QuestaoModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], QuestaoModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], QuestaoModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], QuestaoModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], QuestaoModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], QuestaoModule.prototype, _k, null);
QuestaoModule = __decorate([
    Module
], QuestaoModule);
export default QuestaoModule;
//********** COMENTÁRIO GERADO EM: 18/06/2025 09:27:38 **********
//
//import rotService from "@/core/services/rotService";
//import JwtService from "@/core/services/JwtService";
//import { Mutations } from "@/store/enums/StoreEnums";
//import {QuestaoActions} from "@/store/enums/rotEnums";
//import {Module, Action, VuexModule} from "vuex-module-decorators";
//
//
//@Module
//export default class QuestaoModule extends VuexModule {
//    errors = {};
//    isAuthenticated = !!JwtService.getToken();
//    
//	@Action
//    [QuestaoActions.DOWNLOAD_PLANILHA]() {
//        return new Promise((resolve, reject) => {
//            rotService.getFile("Questao/DownloadPlanilhaModelo")
//                .then((response) => {
//                    const blob = new Blob([response.data], {
//                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//                    });
//
//                    const url = window.URL.createObjectURL(blob);
//                    const link = document.createElement('a');
//                    link.href = url;
//                    link.setAttribute('download', 'Planilha_Modelo_Questao.xlsx');
//                    document.body.appendChild(link);
//                    link.click();
//                    document.body.removeChild(link);
//
//                    resolve(response);
//                })
//                .catch((error) => {
//                    if (error.response) {
//                        this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
//                        reject(error.response.data.errors);
//                    } else {
//                        reject("Erro ao baixar a planilha.");
//                    }
//                });
//        });
//    }
//
//	 @Action
//    [QuestaoActions.UPLOAD_PLANILHA](file: File) {
//        const formData = new FormData();
//        formData.append('file', file); // Adiciona o arquivo ao FormData
//
//        return new Promise((resolve, reject) => {
//            rotService.postFile("Questao/ImportarPlanilha", formData)
//                .then(({ data }) => {
//                    resolve(data); // Sucesso
//                })
//                .catch((error) => {
//                    if (error.response) {
//                        this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
//                        reject(error.response.data.errors); // Rejeita com o erro
//                    } else {
//                        reject("Erro ao enviar a planilha.");
//                    }
//                });
//        });
//    }
//
//    @Action
//    [QuestaoActions.POST_QUESTAO] (data) {
//        return new Promise(resolve => {
//			rotService.post("Questao/Post", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//		});
//    }
//
//	@Action
//	[QuestaoActions.PUT_QUESTAO] (data) {
//        return new Promise(resolve => {
//            rotService.put("Questao/Put", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[QuestaoActions.DELETE_QUESTAO](data) {
//        return new Promise(resolve => {
//            rotService.delete("Questao/Delete", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[QuestaoActions.DELETE_RANGE_QUESTAO](data) {
//        return new Promise(resolve => {
//            rotService.delete("Questao/DeleteRange", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[QuestaoActions.FILTER_QUESTAO](data) {
//        return new Promise(resolve => {
//            rotService.post("Questao/Filter", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[QuestaoActions.GET_QUESTAO]() {
//        return new Promise(resolve => {
//            rotService.get("Questao/Get")
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//    [QuestaoActions.GETWITHDISABLED_QUESTAO]() {
//        return new Promise(resolve => {
//            rotService.get("Questao/GetWithDisabled")
//				  .then(({ data }) => {
//				resolve(data);
//			})
//                .catch (({ response }) => {
//				this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[QuestaoActions.GET_BY_ID_QUESTAO](data) {
//        return new Promise(resolve => {
//            rotService.get("Questao/GetById", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//}
//********** FIM DO COMENTÁRIO **********
//# sourceMappingURL=QuestaoModule.js.map